import { clone } from 'ramda';
import ROUTES from '../../router/routes'

/**
 * ***HeroProps*** = { show: boolean, showInMobile: boolean }
 * @property **show** *[true]* - Show hero on desktop.
 * @property **showInMobile** *[false]* - Show hero on mobile | only applies if heroProps.show is true.
 *
 * ***HeaderProps*** = { show: boolean, marginBottom: string, showInMobile: boolean, whitBackBtn: boolean, overlay: boolean }
 * @property **show** *[true]* - Show header on desktop.
 * @property **showInMobile** *[true]* - Show header on mobile | only applies if headerProps.show is true.
 * @property **marginBottom** *[70px]* - Margin bottom of **header** | only applies if **header** is displayed.
 * @property **whitBackBtn** *[false]* - Show back button on **header** | only applies if **header** is displayed.
 * @property **overlayHeaderMobile** *[false]* - Show **overlayHeader** | only applies on mobile.
 */

const CONFIG = {
  [ROUTES.HOME]: {
    hero: {
      showInMobile: true,
    },
    header: {
      showInMobile: false,
    }
  },
  [ROUTES.DOCUMENT_VERIFICATION]: {
    hero: {
      showInMobile: true,
    },
    header: {
      showInMobile: false,
      whitBackBtn: true,
    }
  },
  [ROUTES.BALANCE_VERIFICATION]: {
    header: {
      overlayHeaderMobile: true,
      whitBackBtn: true,
    }
  },
  [ROUTES.INSUFFICIENT_BALANCE]: {
    header: {
      overlayHeaderMobile: true,
      showInMobile: false,
    }
  },
  [ROUTES.BENEFICIARIES_REGISTER]: {
    header: {
      overlayHeaderMobile: true,
      whitBackBtn: true,
    }
  },
  [ROUTES.MINIMUM_PENSION_ESTIMATE]: {
    header: {
      overlayHeaderMobile: true,
      whitBackBtn: true,
    }
  },
  [ROUTES.ERROR]: {
    hero: {
      show: false,
    },
    header: {
      showInMobile: false,
      overlayHeaderMobile: true,
    },
  },
};

export default (path) => {

  const defaultConfig = {
    hero: {
      show: true,
      showInMobile: false,
    },
    header: {
      show: true,
      showInMobile: true,
      marginBottom: '56px',
      whitBackBtn: false,
      overlayHeaderMobile: false,
    },
  };

  const config = CONFIG[path] || {};

  const heroProps = {
    ...clone(defaultConfig).hero,
    ...clone(config).hero,
  }

  const headerProps = {
    ...clone(defaultConfig).header,
    ...clone(config).header,
  }

  return {
    heroProps,
    headerProps,
  }
}
